/** Quote status → display label */
export const FINANCE_QUOTE_STATUS = {
  DRAFT: "Draft",
  SENT: "Sent",
  PENDING_CHANGES: "Pending Changes",
  APPROVED: "Approved",
  DECLINED: "Declined",
  EXPIRED: "Expired",
} as const;

/** Invoice status → display label */
export const FINANCE_INVOICE_STATUS = {
  DRAFT: "Draft",
  SENT: "Sent",
  PENDING_CHANGES: "Pending Changes",
  PAID: "Paid",
  OVERDUE: "Overdue",
  CANCELLED: "Cancelled",
} as const;

/** Payment terms → display label */
export const FINANCE_PAYMENT_TERMS = {
  DUE_ON_RECEIPT: "Due on receipt",
  NET_15: "Net 15",
  NET_30: "Net 30",
  NET_45: "Net 45",
  NET_60: "Net 60",
  NET_90: "Net 90",
} as const;

/** Line-item unit → display label (quotes, invoices, packages) */
export const FINANCE_LINE_ITEM_UNIT = {
  EACH: "Each",
  MINUTE: "Minute",
  HOUR: "Hour",
  DAY: "Day",
  WEEK: "Week",
  MONTH: "Month",
  YEAR: "Year",
} as const;

export type FinanceQuoteStatus = keyof typeof FINANCE_QUOTE_STATUS;
export type FinanceInvoiceStatus = keyof typeof FINANCE_INVOICE_STATUS;
export type FinancePaymentTerms = keyof typeof FINANCE_PAYMENT_TERMS;
export type FinanceLineItemUnit = keyof typeof FINANCE_LINE_ITEM_UNIT;
